module.exports = __webpack_public_path__ + "static/media/Title.486da852.png";